import { ComponentProps } from 'react'
import styled from 'styled-components'
import { Box } from './Box'

const IconCont = styled.span`
  color: ${({ theme }) => theme.colors.brandPrimary};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  pointer-events: none;
`

export const ChevronDown = () => {
  return (
    <IconCont>
      <svg
        width="16"
        height="10"
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 1L8.18612 7.81387L1.37225 0.999999"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
    </IconCont>
  )
}

export const SelectLabel = styled.label`
  color: var(--white, #f6f8ff);
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: var(--white, #f6f8ff);
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
export const StyledSelectMenu = styled.select`
  width: 100%;
  padding: 12px 16px;
  padding-right: 46px;
  box-sizing: border-box;

  appearance: none;
  outline: none;
  position: relative;

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.textInputBorder};
  background: rgba(255, 255, 255, 0.02);

  color: #fff;
  font-feature-settings: 'dlig' on, 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.56px;
`

export const SelectOption = styled.option``

export const SelectMenu = (props: ComponentProps<typeof StyledSelectMenu>) => {
  return (
    <Box fu aw relative>
      <StyledSelectMenu {...props}>{props.children}</StyledSelectMenu>
      <ChevronDown />
    </Box>
  )
}
